
import {
  LOADING,
  GET_PERK_DATA,
  DELETE_PERK_DATA,
  CREATE_NEW_PERK,
  UPDATE_NEW_PERK,
} from "../types";

const initialState = {
  loading: false,
  perkData: [],
}

function perkReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_PERK_DATA:
      return {
        ...state,
        loading: false,
        perkData: payload
      };
    case CREATE_NEW_PERK:
      return {
        ...state,
        perkData: [payload, ...state.perkData]
      };
    case UPDATE_NEW_PERK:
      const index = state.perkData.findIndex(e => e.id === payload.id);
      const newPerkData = state.perkData;
      newPerkData[index] = { ...newPerkData[index], ...payload };
      return {
        ...state,
        perkData: newPerkData
      };
    case DELETE_PERK_DATA:
      return {
        ...state,
        perkData: state.perkData.filter(e => (payload !== e.id))
      };
    default:
      return state;
  }
}

export default perkReducer;
